import React, { useState } from 'react';
import ProgressSteps from './ProgressSteps';
import { ProgressStepsProps } from './ProgressSteps';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import { Button, ButtonProps } from '../button';
import { IconChevronDown, IconChevronUp } from '@pentabd/icons';
import Text from '../text/Text';

export interface ExpandableProgressStepsProps {
  progressStepsProps: ProgressStepsProps;
  buttonProps?: ButtonProps;
  borderColor?: string;
  backgroundColor?: string;
}

export default function ExpandableProgressSteps({
  progressStepsProps,
  buttonProps,
  borderColor,
  backgroundColor,
}: ExpandableProgressStepsProps) {
  const [height, setHeight] = useState<number | string>(
    progressStepsProps.size === 'lg' ? 70 : 60,
  );
  const defaultHeight = progressStepsProps.size === 'lg' ? 70 : 60;

  return (
    <div
      className={classNames(
        'd-flex w-100 border-start border-4  justify-content-between ${borderColor} rounded px-10 py-10 align-items-start overflow-hidden',
        backgroundColor,
        borderColor,
      )}
    >
      <Button
        fill="transparent"
        isPadding={false}
        type="light"
        onClick={() =>
          setHeight(height === defaultHeight ? 'auto' : defaultHeight)
        }
        className="order-2 pt-5"
        {...buttonProps}
      >
        {height === defaultHeight ? (
          <div className="d-flex align-items-center">
            <Text weight="light" className="me-5">
              Expand
            </Text>
            <IconChevronDown size="20" type="light" />
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <Text weight="light" className="me-5">
              Hide
            </Text>
            <IconChevronUp size="20" type="light" />
          </div>
        )}
      </Button>
      <AnimateHeight
        duration={500}
        height={height as number}
        className="order-1"
      >
        <div>
          <ProgressSteps {...progressStepsProps} />
        </div>
      </AnimateHeight>
    </div>
  );
}
